export function getAuthUrl(_email?: string) {
  // TODO: Implement actual auth endpoint for KindnessGuild
  return "/auth/login";
}

export function sendToAuth(email?: string) {
  if (typeof window === "undefined" || !email?.trim()) return;
  window.location.assign(getAuthUrl(email));
}
